module.exports = __webpack_public_path__ + "static/media/hourclaims.eebe1c5a.png";